import ProductCardHome from './ProductCardHome';
import VideoCard from './VideoCard';
import {
  ProductCarousel,
  ProductGrid,
  SectionHeading,
  VideoCardWrapper,
} from './styled';
import Image from 'next/image';
import { isDesktopUser } from '../../../Utils/ProductUtils';

function ProductContainer(props) {
  const {
    data,
    isForJoyfulPage,
    showNewProductVideoCardUx,
    setChangeCartCount,
    fitHeadingImage,
    increasedWidth,
    fromCategoryPage,
    scrollRef,
    onScroll,
    dynamicImageHeight,
    hideSpecialPriceStrip,
    backgroundColor,
    showBottomImage,
  } = props;

  const desktop = isDesktopUser();

  const renderProductItem = (data) => {
    switch (data?.viewType) {
      case 'GRID':
        return (
          <ProductGrid>
            {data?.videoUrl && (
              <VideoCard
                url={data?.videoUrl}
                {...(showNewProductVideoCardUx
                  ? {
                      videoTitle: data?.videoTitle,
                      videoDescription: data?.videoDescription,
                    }
                  : {})}
              />
            )}
            {data?.items?.map((element, index) => (
              <ProductCardHome
                itemId={`element-${index}`}
                productInfo={element}
                setChangeCartCount={setChangeCartCount}
                key={`element-${element?._id}${index}`}
                store={true}
                isForJoyfulPage={isForJoyfulPage}
                showNewProductVideoCardUx={showNewProductVideoCardUx}
              />
            ))}
          </ProductGrid>
        );
      case 'HORIZONTAL':
        return (
          <ProductCarousel
            increasedWidth={increasedWidth}
            fromCategoryPage={fromCategoryPage}
            ref={scrollRef}
            onScroll={onScroll}
          >
            {data?.videoUrl && (
              <VideoCardWrapper>
                <VideoCard
                  url={data?.videoUrl}
                  videoTitle={data?.videoTitle}
                  videoDescription={data?.videoDescription}
                  backgroundColor={backgroundColor}
                  sectionBgColor={data?.sectionBgColorStart}
                />
              </VideoCardWrapper>
            )}
            {data?.items?.map((element, index) => (
              <ProductCardHome
                itemId={`element-${index}`}
                productInfo={element}
                setChangeCartCount={setChangeCartCount}
                key={`element-${element?._id}${index}`}
                store={true}
                isForJoyfulPage={isForJoyfulPage}
                showNewProductVideoCardUx={showNewProductVideoCardUx}
                carousel={true}
                showSpecialPriceStrip={!hideSpecialPriceStrip}
                section={data} // pass section
                isParentingPage={false} // if needed
              />
            ))}
          </ProductCarousel>
        );
      default:
        return (
          <ProductGrid>
            {data?.videoUrl && (
              <VideoCard
                url={data?.videoUrl}
                {...(showNewProductVideoCardUx
                  ? {
                      videoTitle: data?.videoTitle,
                      videoDescription: data?.videoDescription,
                    }
                  : {})}
              />
            )}
            {data?.items?.map((element, index) => (
              <ProductCardHome
                itemId={`element-${index}`}
                productInfo={element}
                setChangeCartCount={setChangeCartCount}
                key={`element-${element?._id}${index}`}
                store={true}
                isForJoyfulPage={isForJoyfulPage}
                showNewProductVideoCardUx={showNewProductVideoCardUx}
              />
            ))}
          </ProductGrid>
        );
    }
  };

  const getSectionHeadingImage = () => {
    if (desktop) {
      return (
        data.desktopSectionBgImage ||
        data.sectionBgImage ||
        data.sectionTopBgImage
      );
    } else {
      return data.sectionBgImage || data.sectionTopBgImage;
    }
  };

  return (
    <div>
      {dynamicImageHeight ? (
        <img
          alt=""
          width="100%"
          height="100%"
          src={getSectionHeadingImage()}
          style={{ objectFit: 'contain', display: 'block' }}
        />
      ) : (
        <SectionHeading
          fitHeadingImage={fitHeadingImage && desktop}
          style={
            showNewProductVideoCardUx
              ? { marginTop: '0px', paddingTop: '0px' }
              : {}
          }
        >
          {fitHeadingImage && desktop ? (
            <img
              increasedWidth={increasedWidth}
              src={getSectionHeadingImage()}
              alt="Section Heading Image"
              width={increasedWidth ? '98%' : fromCategoryPage ? '80%' : '70%'}
              margin="auto"
            />
          ) : (
            <Image
              src={data.sectionBgImage || data.sectionTopBgImage}
              alt="Section Heading Image"
              priority={true}
              loading={'eager'}
              fill
              sizes="100vw"
            />
          )}
        </SectionHeading>
      )}
      {renderProductItem(data)}
      {showBottomImage && data?.generalItemBgImage && (
        <img
          alt=""
          width="100%"
          height="100%"
          src={data.generalItemBgImage}
          style={{ objectFit: 'contain', display: 'block' }}
        />
      )}
    </div>
  );
}

export default ProductContainer;
